import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates an email address against a specific regular expression.
 *
 * @returns A validator function that returns an error map with `invalidEmailFormat` if validation fails, otherwise null.
 */
export function emailRegexpValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values, let 'required' validator handle it
    }
    const emailRegex = new RegExp(
      "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}$"
    );
    const valid = emailRegex.test(control.value);
    return valid ? null : { invalidEmailFormat: { value: control.value } };
  };
}
